// extracted by mini-css-extract-plugin
export default {"inputWrapper":"Rko5p9","input":"CbXY82"};